import React from 'react';

const Blank : React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <>
      {children}
    </>
  );
};

export default Blank;
